import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import FeedbackModal from './FeedbackModal'; 
import './Navbar.css'; 

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

  const menuItems = [
    { name: 'Home', href: '#hero' },
    { name: 'Structure', href: '#structure' },
    { name: 'Documentation', href: '#documentation' },
    { 
      name: 'Feedback', 
      onClick: () => {
        setIsFeedbackOpen(true);
        setIsOpen(false);
      } 
    },
  ];

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <>
      <nav className="navbar-container">
        <div className="logo">VIX1ON</div>

        <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        <AnimatePresence>
          {isOpen && (
            <>
              <motion.div 
                className="nav-overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={toggleMenu}
              />

              <motion.div 
                className="nav-menu"
                initial={{ x: '100%' }}
                animate={{ x: 0 }}
                exit={{ x: '100%' }}
                transition={{ type: 'spring', damping: 25, stiffness: 200 }}
              >
                <ul className="nav-links">
                  {menuItems.map((item, index) => (
                    <motion.li 
                      key={index}
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.1 * index }}
                    >
                      {item.href ? (
                        <a href={item.href} onClick={toggleMenu} className="nav-item">
                          {item.name}
                          <span className="hover-line"></span>
                        </a>
                      ) : (
                        <button onClick={item.onClick} className="nav-item nav-btn-text">
                          {item.name}
                          <span className="hover-line"></span>
                        </button>
                      )}
                    </motion.li>
                  ))}
                </ul>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </nav>

      <FeedbackModal 
        isOpen={isFeedbackOpen} 
        onClose={() => setIsFeedbackOpen(false)} 
      />
    </>
  );
};

export default Navbar;